import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { getLanguageLabel } from "../../../utils/helpers";
import { UserType } from "../../../utils/enum";
import useAuth from "../../../hooks/useAuth";
import AddLanguagesModal from "../../CompleteYourProfile/components/AddLanguagesModal";

const Language = ({ languages = [], userId, refetchAllUserLanguages }) => {
  const { authRole } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <BaseCard className="py-2 px-8 sm:px-10 rounded-lg" elevation={1}>
      <div className="bg-light -mx-4 px-4 py-2 mt-2 mb-4 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Languages</h6>
        {authRole === UserType.ADMIN && (
          <i
            className="fa-light fa-pencil text-gray-900 cursor-pointer"
            style={{ cursor: "pointer" }}
            onClick={() => setIsModalOpen(true)}
          ></i>
        )}
      </div>

      <div className="flex flex-wrap mt-5 overflow-hidden">
        {languages?.map((language, index) => (
          <p
            key={index}
            className="bg-light py-1 px-4 rounded-md mr-4 mb-2 cursor-pointer whitespace-nowrap"
          >
            {getLanguageLabel(language?.language)} - {language?.proficiency}
          </p>
        ))}
      </div>

      {isModalOpen && (
        <AddLanguagesModal
          open={isModalOpen}
          close={setIsModalOpen}
          refetchAllUserLanguages={refetchAllUserLanguages}
          languagesData={{ data: languages }}
          targetUserId={userId}
        />
      )}
    </BaseCard>
  );
};

export default Language;
